import { PRODUCT_NAV_IT, PRODUCT_NAV_EN } from '@/data/productPages';

export const SOLUTION_MENU = {
  overview: {
    label: 'Panoramica',
    description: 'Esplora le quattro aree e parti dalla tua situazione, prima che dal nome di una polizza.',
    href: '/soluzioni',
  },
  areasLabel: 'Le quattro aree',
  productsLabel: 'Assicurazioni e temi',
  productsHint: 'Passa il mouse su un’area per vedere tutte le soluzioni collegate.',
  areas: [
    {
      key: 'salute', label: 'Cassa Malati', href: '/cassa-malati', icon: 'HeartPulse',
      description: 'Cure, infortuni e protezione del reddito.',
      products: [{ label: 'Calcolatore premi 2026–2027', href: '/cassa-malati/calcolatore-premi' }, ...PRODUCT_NAV_IT.salute],
    },
    {
      key: 'privati', label: 'Privati', href: '/soluzioni/privati', icon: 'Home',
      description: 'Casa, famiglia, mobilità e patrimonio.',
      products: PRODUCT_NAV_IT.privati,
    },
    {
      key: 'aziende', label: 'Aziende', href: '/soluzioni/aziende', icon: 'Building2',
      description: 'Persone, responsabilità e continuità.',
      products: PRODUCT_NAV_IT.aziende,
    },
    {
      key: 'previdenza', label: 'Previdenza', href: '/soluzioni/previdenza', icon: 'PiggyBank',
      description: 'LPP, lacune, famiglia e pensionamento.',
      products: PRODUCT_NAV_IT.previdenza,
    },
  ],
};

export const SOLUTION_MENU_EN = {
  overview: {
    label: 'Overview',
    description: 'Explore the four areas and start from your situation before choosing a policy.',
    href: '/soluzioni',
  },
  areasLabel: 'Four areas',
  productsLabel: 'Insurance and topics',
  productsHint: 'Hover or focus an area to view all related solutions.',
  areas: [
    {
      key: 'salute', label: 'Health', href: '/cassa-malati', icon: 'HeartPulse',
      description: 'Care, accidents and income protection.',
      products: [{ label: 'Premium calculator 2026–2027', href: '/cassa-malati/calcolatore-premi' }, ...PRODUCT_NAV_EN.salute],
    },
    {
      key: 'privati', label: 'Individuals', href: '/soluzioni/privati', icon: 'Home',
      description: 'Home, family, mobility and assets.',
      products: PRODUCT_NAV_EN.privati,
    },
    {
      key: 'aziende', label: 'Businesses', href: '/soluzioni/aziende', icon: 'Building2',
      description: 'People, liability and continuity.',
      products: PRODUCT_NAV_EN.aziende,
    },
    {
      key: 'previdenza', label: 'Pension', href: '/soluzioni/previdenza', icon: 'PiggyBank',
      description: 'LPP, gaps, family and retirement.',
      products: PRODUCT_NAV_EN.previdenza,
    },
  ],
};
